import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0
    
}
const mutations={
   
  
    getOrderProfitsData(state,value){
        
        
     
        post(urls.admin.order_profits.index,value).then((result)=>{
          
          
          
          state.result=result

        
        
       
        
       
           
        });
        
    },
    getOrderProfitsDetail(state,value){
        
        
       
        post(urls.admin.order_profits.detail,value).then((result)=>{
          
          
          
          state.result=result
        
       
        
       
           
        });
        
    },
  
    orderProfitsSettlement(state,value){
        
        
       
        post(urls.admin.order_profits.settlement,value).then((result)=>{
          
          
          
          state.result=result
        
       
        
       
           
        });
        
    },
   
   
    

}
const  actions={
    getOrderProfitsDataAction(context,value){
       
        context.commit("getOrderProfitsData",value)
       
    },
    getOrderProfitsDetailAction(context,value){
       
        context.commit("getOrderProfitsDetail",value)
       
    },
    orderProfitsSettlementAction(context,value){
       
        context.commit("orderProfitsSettlement",value)
       
    },
    
  
    
   

}

export default {state,mutations,actions}